import {i18n} from '@/plugins/i18n';
import {profitSettlementTypeStr, profitSettlementTypeVariant} from "@/constants/profitSettlementType";

export default [
    {
        field: 'id',
        title: i18n.t('label.hashid'),
        textAlign: 'center',
    },
    {
        field: 'wallet',
        title: i18n.t('label.daily_profit.wallet'),
        textAlign: 'center',
    },
    {
        field: 'gateway',
        title: i18n.t('label.daily_profit.gateway'),
        textAlign: 'center',
    },
    {
        field: 'marketing',
        title: i18n.t('label.daily_profit.marketing'),
        textAlign: 'center',
    },
    {
        field: 'total',
        title: i18n.t('label.daily_profit.total'),
        textAlign: 'center',
    },
    {
        field: 'system_settled',
        title: i18n.t('label.daily_profit.system_settled'),
        textAlign: 'center',
    },
    {
        field: 'settlement_type',
        title: i18n.t('label.daily_profit.settlement_type'),
        textAlign: 'center',
        template: row => {
            return `
                <span class="badge badge-${profitSettlementTypeVariant(row.settlement_type)}">
                    ${profitSettlementTypeStr.get(row.settlement_type)}
                </span>
            `;
        },
    },
    {
        field: 'date',
        title: i18n.t('label.daily_profit.date'),
        textAlign: 'center',
    },
]
